export interface DocFile {
  label: string;
  url: string;
}

export interface DocItem {
  id: string;
  title: string;
  titleRu?: string;
  titleKk?: string;
  titleEn?: string;
  files: DocFile[];
}

export const documentsData: DocItem[] = [];

export const patriotDocumentsData: DocItem[] = [];